import { Card, Flex, Tag, Typography } from 'antd';
import { RuleActionsDropdown } from './RuleActionsDropdown';
import { RuleGroupActionsDropdown } from './RuleGroupActionsDropdown';
import { RuleValueDisplay } from './RuleValueDisplay';

const { Text } = Typography;

export const RuleGroupCard = ({
  ruleGroup,
  level = 0,
  parentActive = true,
  getOperatorLabel,
  getOperatorDescription,
  onChange,
  onEdit,
  agreementId,
  showRuleActions = true,
  showGroupActions = true,
}) => {
  const hasRules = ruleGroup.rules && ruleGroup.rules.length > 0;
  const hasChildren = ruleGroup.children && ruleGroup.children.length > 0;
  const isEmpty = !hasRules && !hasChildren;

  const operatorDescription = getOperatorDescription(ruleGroup.operator);
  const isActive = ruleGroup.active !== false;
  const childrenCanInteract = parentActive && isActive;

  // Para el nivel raíz (level 0), no usar Card, solo mostrar contenido
  if (level === 0) {
    return (
      <Flex vertical gap='small'>
        <Text strong type='secondary'>
          {operatorDescription}
        </Text>
        <Flex vertical gap={0}>
          {hasRules && ruleGroup.rules.map((rule, index) => {
            const fieldLabel = rule.field?.label || 'Campo';
            const operatorLabel = getOperatorLabel(rule.operator);
            const isRuleActive = rule.active !== false;

            return (
              <Card
                key={`rule-${rule.id || index}`}
                size='small'
                style={{
                  marginTop: -1,
                  borderColor: '#d9d9d9',
                  backgroundColor: 'transparent',
                }}
                styles={{
                  body: { paddingInline: '3%' },
                }}
              >
                <Flex justify='space-between' align='center' gap='small'>
                  <Flex align='center' gap='small' flex={1}>
                    <Text style={{ fontSize: '0.9em' }}>
                      <Text strong>{fieldLabel}</Text>
                      {' '}
                      <Text type='secondary'>{operatorLabel}</Text>
                      {' '}
                      <Text strong><RuleValueDisplay rule={rule} /></Text>
                    </Text>
                    <Tag color={isRuleActive ? 'green' : 'red'}>
                      {isRuleActive ? 'Activo' : 'Inactivo'}
                    </Tag>
                  </Flex>
                  {showRuleActions && (
                    <RuleActionsDropdown
                      rule={rule}
                      ruleGroup={ruleGroup}
                      agreementId={agreementId}
                      onChange={onChange}
                    />
                  )}
                </Flex>
              </Card>
            );
          })}

          {isEmpty && (
            <Text type='secondary' italic style={{ fontSize: '0.9em', paddingLeft: 8 }}>
              Sin condiciones definidas
            </Text>
          )}

          {hasChildren && ruleGroup.children.map((childGroup) => (
              <RuleGroupCard
                key={childGroup.id}
                ruleGroup={childGroup}
                level={level + 1}
                parentActive={isActive}
                getOperatorLabel={getOperatorLabel}
                getOperatorDescription={getOperatorDescription}
                onChange={onChange}
                onEdit={onEdit}
                agreementId={agreementId}
                showRuleActions={showRuleActions}
                showGroupActions={showGroupActions}
              />
          ))}
        </Flex>
      </Flex>
    );
  }

  return (
    <Card
      size='small'
      style={{
        marginTop: -1,
        borderColor: '#d9d9d9',
        backgroundColor: 'transparent',
      }}
      styles={{
        body: { paddingInline: '3%' },
      }}
    >
      <Flex vertical gap='small'>
        <Flex justify='space-between' align='center' wrap='wrap' gap='small'>
          <Flex align='center' gap='small' flex={1}>
            <Text strong type='secondary'>
              {operatorDescription}
            </Text>
            <Tag color={isActive ? 'green' : 'red'}>
              {isActive ? 'Activo' : 'Inactivo'}
            </Tag>
          </Flex>
          {showGroupActions && (
            <RuleGroupActionsDropdown
              ruleGroup={ruleGroup}
              onChange={onChange}
              onEdit={level === 0 ? onEdit : undefined}
            />
          )}
        </Flex>

        <Flex vertical gap={0}>
          {hasRules && ruleGroup.rules.map((rule, index) => {
            const fieldLabel = rule.field?.label || 'Campo';
            const operatorLabel = getOperatorLabel(rule.operator);
            const isRuleActive = rule.active !== false;

            return (
              <Card
                key={`rule-${rule.id || index}`}
                size='small'
                style={{
                  marginTop: -1,
                  borderColor: '#d9d9d9',
                  backgroundColor: 'transparent',
                }}
                styles={{
                  body: { paddingInline: '3%' },
                }}
              >
                <Flex justify='space-between' align='center' gap='small'>
                  <Flex align='center' gap='small' flex={1}>
                    <Text style={{ fontSize: '0.9em' }}>
                      <Text strong>{fieldLabel}</Text>
                      {' '}
                      <Text type='secondary'>{operatorLabel}</Text>
                      {' '}
                      <Text strong><RuleValueDisplay rule={rule} /></Text>
                    </Text>
                    <Tag color={isRuleActive ? 'green' : 'red'}>
                      {isRuleActive ? 'Activo' : 'Inactivo'}
                    </Tag>
                  </Flex>
                  {showRuleActions && (
                    <RuleActionsDropdown
                      rule={rule}
                      ruleGroup={ruleGroup}
                      agreementId={agreementId}
                      onChange={onChange}
                    />
                  )}
                </Flex>
              </Card>
            );
          })}

          {isEmpty && (
            <Text type='secondary' italic style={{ fontSize: '0.9em', paddingLeft: 8 }}>
              Sin condiciones definidas
            </Text>
          )}

          {hasChildren && ruleGroup.children.map((childGroup) => (
            <div key={childGroup.id} style={{ opacity: isActive ? 1 : 0.5, pointerEvents: isActive ? 'auto' : 'none' }}>
              <RuleGroupCard
                ruleGroup={childGroup}
                level={level + 1}
                parentActive={childrenCanInteract}
                getOperatorLabel={getOperatorLabel}
                getOperatorDescription={getOperatorDescription}
                onChange={onChange}
                onEdit={onEdit}
                agreementId={agreementId}
                showRuleActions={showRuleActions}
                showGroupActions={showGroupActions}
              />
            </div>
          ))}
        </Flex>
      </Flex>
    </Card>
  );
};
